import { z } from "zod"
import { electricityMeterPointIdSchema } from "@/features/meter-points"
import { getNameSchema } from "@/schemas/getNameSchema"

export const MeterPointPmaxSchema = z.object({
    meterPointId: electricityMeterPointIdSchema,
    user: z.object({
        firstName: getNameSchema({
            requiredErrorMessage: "Prénom requis",
            invalidErrorMessage: "Format du prénom invalide",
        }),
        lastName: getNameSchema({
            requiredErrorMessage: "Nom requis",
            invalidErrorMessage: "Format du nom invalide",
        }),
    }),
})
